import {
  isApiErrorSelector,
  isAccessErrorSelector,
  isAssessmentNotAvailableErrorSelector,
  isMultipleLoginErrorSelector,
  setApiConfig,
  setApiError,
  setMultipleLoginError,
  setAccessError,
  setAssessmentNotAvailableError,
  isSubmitApiErrorSelector
} from 'app/reducer/errorSlice'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'app/hooks'
import { logout } from 'app/reducer/authSlice'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import styled from 'styled-components'
import ActionButton from 'components/ActionButton'
import {
  ModalActions,
  ModalCard,
  ModalMessage,
  ModalOverlay,
  ModalTitle
} from 'components/modals/styles'

const Overlay = styled(ModalOverlay)`
  z-index: 10020;
`

const Card = styled(ModalCard)`
  width: 500px;
  max-width: 500px;
  border-radius: 8px;
  padding: 16px 24px;
`

const Header = styled.div`
  margin-bottom: 10px;
`

const Body = styled.div`
  margin-bottom: 10px;
`

const Message = styled(ModalMessage)`
  margin-left: 0;
`

const MessageRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const Footer = styled(ModalActions)`
  margin-top: 14px;
`

const ApiResponseModal = () => {
  const isSubmitApiError = useSelector(isSubmitApiErrorSelector)
  const isApiError = useSelector(isApiErrorSelector)
  const isAccessError = useSelector(isAccessErrorSelector)
  const isAssessmentNotAvailableError = useSelector(
    isAssessmentNotAvailableErrorSelector
  )
  const isMultipleLoginError = useSelector(isMultipleLoginErrorSelector)
  const isError =
    isApiError ||
    isAccessError ||
    isMultipleLoginError ||
    isAssessmentNotAvailableError
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const logoutStudent = () => {
    dispatch(logout())
    removeErrors()
    navigate('/')
  }

  const backToAssessmentSelection = () => {
    removeErrors()
    navigate('/classroom')
  }

  const removeErrors = () => {
    dispatch(setApiConfig(null))
    dispatch(setApiError(false))
    dispatch(setAccessError(false))
    dispatch(setAssessmentNotAvailableError(false))
    dispatch(setMultipleLoginError(false))
  }

  const onClickActionBtn = () => {
    logoutStudent()
  }

  // this need to be added on login screen! Revision required
  useEffect(() => {
    if (location.pathname === '/') {
      removeErrors()
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  })

  return (
    <div className={`${isError && 'mainContent-backDrop'}`}>
      {isError ? (
        <Overlay>
          <Card
            role='dialog'
            aria-modal='true'
            aria-labelledby='api-error-title'
          >
            <Header>
              <ModalTitle id='api-error-title'>
                {isMultipleLoginError
                  ? 'Multiple Logins'
                  : isAccessError
                    ? 'Access Denied'
                    : isAssessmentNotAvailableError
                      ? 'Assessment Not Available'
                      : 'Connection Error'}
              </ModalTitle>
            </Header>
            <Body>
              {isMultipleLoginError ? (
                <Message>
                  This student account is logged into the Student Portal in
                  another browser. You will now be logged out.
                </Message>
              ) : isAccessError ? (
                <Message>Something went wrong. Please try again later.</Message>
              ) : isAssessmentNotAvailableError ? (
                <Message>This assessment is no longer available.</Message>
              ) : isSubmitApiError ? (
                <div>
                  <MessageRow>
                    <Message>
                      Your assessment is being submitted. Please Wait.
                    </Message>
                    <div className='dot-flashing'></div>
                  </MessageRow>
                  <Message>
                    This error may occur due to slow internet connection.
                  </Message>
                </div>
              ) : (
                <Message>
                  Your connection to the Alpha Plus servers is having trouble.
                  This message will automatically close when the connection is
                  restored.
                </Message>
              )}
            </Body>
            <Footer>
              <ActionButton
                label='Log Out'
                variant={isAssessmentNotAvailableError ? 'clear' : 'error'}
                width={isAssessmentNotAvailableError ? 102 : 98}
                onClick={onClickActionBtn}
              />
              {isAssessmentNotAvailableError && (
                <ActionButton
                  label='View Assessments'
                  variant='info-dark'
                  width={170}
                  onClick={backToAssessmentSelection}
                />
              )}
            </Footer>
          </Card>
        </Overlay>
      ) : null}
    </div>
  )
}
export default ApiResponseModal
